import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Constants } from '@shared/utils/constants';
import { SignInModal } from '@shared/components/modals/signInModal';
import { getSignInModalType, getCTATypeForActionString } from '@shared/utils/appUtils';
import { RatingModal } from '@shared/containers/modals/ratingModal';
export function handleRatingModal(props, appData, dismissModal, service) {
    let modalContent = null;
    const ctaType = getCTATypeForActionString(props.payload.ctaType);
    const signinType = getSignInModalType(appData && appData.primaryProduct, appData && appData.products, props.userInfo, ctaType, !!service);
    const shouldShowSignInModal = signinType !== Constants.SignInType.Authorized && !props.isEmbedded;
    const signinRedirect = 'review';
    const entityType = !!service && !appData ? Constants.EntityType.Service : Constants.EntityType.App;
    if (shouldShowSignInModal) {
        const appTitle = appData && appData.title ? appData.title : '';
        const userEmail = props.userInfo && props.userInfo.email ? props.userInfo.email : '';
        modalContent = /*#__PURE__*/ _jsx(SignInModal, {
            redirect: signinRedirect,
            entityId: appData.entityId,
            dismissModal: dismissModal,
            signInModalType: signinType,
            appName: appTitle,
            email: userEmail,
            entityType: entityType,
            ctaType: ctaType,
            reviewAppId: appData.entityId
        });
    } else {
        const payload = props.payload;
        modalContent = /*#__PURE__*/ _jsx(RatingModal, {
            payload: payload,
            dismissModal: dismissModal,
            setUserReviewStatus: props.setUserReviewStatus
        });
    }
    return modalContent;
}
